import { axiosClient } from '@/features'
import { ApiRoutes } from '@/routes'
import { getUrl } from '@/shared/helpers/url'

export interface Init2FAResponse {
  secret: string;
}

export const totpService = {
  init2fa: async (): Promise<string> => {
    const res = await axiosClient.post<Init2FAResponse>(ApiRoutes.AUTH_INIT_TOTP)
    return res.data.secret
  },

  confirm2fa: async (code: string) => {
    const res = await axiosClient.post(ApiRoutes.AUTH_CONFIRM_TOTP, {
      code,
    })
    return res.data
  },

  verify2fa: async (userId: string, code: string) => {
    const res = await axiosClient.post(ApiRoutes.AUTH_VERIFY_TOTP, {
      userId,
      code,
    })
    return res.data
  },

  deleteTotp: async (userId: string) => {
    const res = await axiosClient.delete(getUrl(ApiRoutes.AUTH_DELETE_TOTP, { userId, type: 'TOTP' }))
    return res.data
  },

  initImmediately: async (userId: string) => {
    const res = await axiosClient.post<Init2FAResponse>(ApiRoutes.PUB_TOTP_START, {
      userId,
    })
    return res.data.secret
  },

  confirmImmediately: async (userId: string, code: string) => {
    const res = await axiosClient.post<Init2FAResponse>(ApiRoutes.PUB_TOTP_FINISH, {
      userId,
      code,
    })
    return res.data
  },
}
